import React from 'react'
import ErrorPage from 'next/error'
import { CmsPage } from '../components/page'
import { withRequestParsing } from '../lib/mixins/with-request-parsing'
import { BasePageProps, withServices } from '../lib/mixins/with-services'
import { TypePage } from '../lib/types'
import { withTelemetry } from '../lib/mixins/with-telemetry'

interface RenderProps extends BasePageProps {
  page?: TypePage
}

const Render: React.FunctionComponent<RenderProps> = withServices(
  withTelemetry(({ page }: RenderProps) => {
    if (!page) {
      return <ErrorPage statusCode={500} />
    }
    return <CmsPage pageStructure={page} />
  })
)

export const getServerSideProps = withRequestParsing<RenderProps>(async ({ requestData }) => {
  return {
    page: requestData?.pageEntry,
  }
})

export default Render
